{
  "users": {
    "page": {
      "title": "",
      "subtitle": ""
    },
    "toolbar": {
      "invite": "",
      "search_placeholder": "",
      "all_roles": "",
      "all_statuses": ""
    },
    "column": {
      "user": "",
      "role": "",
      "last_signin": "",
      "status": "",
      "created": ""
    }
  },
  "audit_log": {
    "page": {
      "title": ""
    },
    "toolbar": {
      "search_placeholder": "",
      "all_domains": "",
      "all_severities": "",
      "all_actors": "",
      "export_csv": ""
    },
    "severity": {
      "info": "INFO",
      "notable": "NOTABLE",
      "high": "HIGH"
    }
  }
}
